import { useState, useEffect } from "react";
import { useAuth } from "../../../provider";
import axios from 'axios';
import PageProtectedOnboarding from "../../../components/Page/PageProtectedOnboarding";
import { Grid, Typography, Box, Paper, CircularProgress, Stack } from '@mui/material';
import { pool } from "../../../constants";
import OnboardingSteps from "../../../components/Steps/OnboardingSteps";
import UserDataFormNew from "../CompleteData/UserDataFormNew";
import * as c from '../../../constants';
import { useTranslation } from "../../../language";


export default function OnboardingData() {    

  const { t, changeLanguage } = useTranslation();
  const { state } = useAuth();
  const [visits, setVisits] = useState([]);

  //const [subscription, setSubscription] = useState(null);
  //const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (state.user?.language) {
      changeLanguage(state.user.language);
    }
  }, [state.user?.language]);

// Fetch visits
  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const res = await axios.get(`${c.API_URL}/api/current-lab-visit/`);
        const data = res.data;

      // Wrap in array for consistent mapping
      const visitsArray = data ? [data] : [];
      setVisits(visitsArray);
     
    } catch (err) {
      console.error("No existing lab visit found:", err);
    }
  };

  if (state?.user?.id) fetchVisits();
}, [state.user?.id]);


return (


<PageProtectedOnboarding
  
      headerImage={pool}
      brandtext="Preventive Health Intelligence"
      headline={t("onb_subscr00")}

      content={<>

     {/* Onboarding Steps */}
      <Grid container sx={{ mt: 4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Grid size={12} sx={{ width: '100%', maxWidth: 900, px: { xs: 1, sm: 2 }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <OnboardingSteps stepNumber={2} />
        </Grid>
      </Grid>
       
     {/* Explain status */}
<Grid container spacing={2} sx={{ mt: 4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Typography variant="subtitle1" textAlign="center" gutterBottom sx={{ mb: 2 }}> 
      {t("onb_subscr22")}  
    </Typography>
  </Grid>

  {/* Lab Visit Date and Time */}
    <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Box sx={{ maxWidth: 600, width: '100%', display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', px: { xs: 2, sm: 0 } }}>
        {Array.isArray(visits) && visits.length > 0 ? (
          visits.map((visit) => (
            <Paper
              key={visit.id}
              elevation={2}
              sx={{
                px: { xs: 2, sm: 4 },
                py: 1,
                borderRadius: 2,
                width: '100%',
                maxWidth: 500,
                display: "flex",
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                bgcolor: 'grey.C50'
              }}
            >
              <Typography variant="subtitle1" fontWeight={400}>
                {`${visit.laboratory?.name}`}
              </Typography>
              <Typography variant="subtitle1" fontWeight={400}>
                {t("onb_visit_date_label")} {visit.visit_date}
              </Typography>
              <Typography variant="subtitle1" fontWeight={400}>
                {t("onb_visit_time_label")} {visit.visit_time.slice(0, 5)}
              </Typography>
            </Paper>
          ))
        ) : (
          <Typography variant="body1" sx={{ color: "text.secondary", mt: 1 }}>
            {t("onb_no_visits")}
          </Typography>
        )}
      </Box>
    </Grid>
   </Grid>

{/* Reschedule app */}  
  <Grid container spacing={2} sx={{ mt: 4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, px: { xs: 3, sm: 0 } }}>
      <Typography variant="subtitle1" textAlign="center" gutterBottom sx={{ mb: 2, fontWeight: 400 }}>
        {t("onb_subscr23")}
      </Typography>
    </Grid>
  </Grid>
        
{/* Complete Data */}
  <Grid container justifyContent="center" alignItems="center" sx={{ mt: 4, px: { xs: 2, sm: 1 }, display: 'flex' }}>
    <Grid size={{xs: 12}} sx={{ maxWidth: 240, mx: 'auto' }}>
      <UserDataFormNew />
    </Grid>
  </Grid>
  </>}
/>
)}


